import { TeamService as OvermapTeamService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class TeamService extends OvermapTeamService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
